import { TableRow, withStyles } from "@material-ui/core";

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:hover": {
      backgroundColor: `hsl(from ${theme.palette.primary.main} h s calc(l + 64)) !important`,
    },
    "&:nth-of-type(odd)": {
			// backgroundColor: theme.palette.action.hover,
      "& td": {
        // color:'#192A7F'
      },
    },
    "&:nth-of-type(even)": {
      // backgroundColor: theme.palette.action.hover,
      "& td": {
        // color:'#2196C0'
      },
    },
  },
}))(TableRow);

export default StyledTableRow;
